import React, { useState } from "react";
import styled from "styled-components";

import { Tooltips } from ".";
import { ReactComponent as CloseIcon } from "../assets/svg/closeIcon.svg";

export const PracticeCircles: React.FC<{}> = () => {
  const [activeCircle, setActiveCircle] = useState<number>(-1);

  const handleClick = (id: number) => {
    return id === activeCircle ? setActiveCircle(-1) : setActiveCircle(id);
  };

  const practiceCircleData = [
    {
      title: "Policy",
      description: (
        <small className="d-block mb-2">
          A policy is a written document setting out an organisation’s intention
          in relation to managing employee health and wellbeing.
          <Tooltips id={24} /> A health policy demonstrates the commitment of
          your organisation to providing a work environment that encourages good
          health.
        </small>
      ),
    },
    {
      title: "Environment",
      description: (
        <small className="d-block mb-2">
          The physical workplace environment (infrastructure and facilities)
          should support and reinforce your health-related policies, education
          and activities in order to make healthy choices the easy choices.
          <Tooltips id={24} /> Even small improvements can significantly
          increase the health of your employees.
        </small>
      ),
    },
    {
      title: "Education and Activities",
      description: (
        <small className="d-block mb-2">
          Education provides employees with knowledge on how their behaviours
          affect their health, which may motivate them to make healthier
          choices. Activities provide an opportunity for employees to practice
          new skills in a non-judgemental environment. Education and activities
          alone, however, is the least likely of the three elements to bring
          about changes in personal behaviour.
        </small>
      ),
    },
  ];

  return (
    <div className="w-100 d-block mx-auto" style={{ overflow: "hidden" }}>
      <ThreeCircles className="col-md-10 offset-md-1">
        {practiceCircleData.map(({ title, description }, idx) => (
          <CircleContainer key={idx} active={idx === activeCircle}>
            <Circle
              active={idx === activeCircle}
              onClick={() => handleClick(idx)}
            >
              <h3 className="text-gold">{title}</h3>
              {description}
              {idx === activeCircle && (
                <CloseIcon
                  css={`
                    fill: white;
                  `}
                  width={20}
                  height={20}
                />
              )}
            </Circle>
          </CircleContainer>
        ))}
      </ThreeCircles>
    </div>
  );
};

const ThreeCircles = styled.div`
  position: relative;
  height: 550px;
`;

const CircleContainer = styled.div<{ active: boolean }>`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  transition: transform 600ms cubic-bezier(0.34, 1.56, 0.64, 1);
  transform: ${(p) => (p.active ? "scale(1.5)" : "scale(1)")};
  z-index: ${(p) => (p.active ? 2 : 1)};
  &:nth-of-type(1) {
    top: 0;
    left: calc(50% - 150px);
    transform-origin: top center;
  }
  &:nth-of-type(2) {
    top: 200px;
    left: calc(50% - 250px);
    transform-origin: bottom left;
  }
  &:nth-of-type(3) {
    top: 200px;
    left: calc(50%);
    transform-origin: bottom right;
  }
`;

const Circle = styled.button<{ active: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  overflow: hidden;
  display: block;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: ${(p) => (p.active ? "center" : "flex-start")};
  align-items: center;
  margin: auto;
  background: ${(p) => (p.active ? p.theme.info : "rgba(255, 255, 255, 0.2)")};
  transition: all 600ms cubic-bezier(0.34, 1.56, 0.64, 1);
  border: none;
  &:focus {
    outline: none;
  }
  & h3 {
    font-size: 1.25rem;
    transition: all 600ms cubic-bezier(0.34, 1.56, 0.64, 1);
    margin: 0 2rem;
    margin-top: ${(p) => (p.active ? "1rem" : "45%")};
    margin-bottom: 1rem;
  }
  & small {
    transition: all 400ms cubic-bezier(0.34, 1.56, 0.64, 1);
    color: ${(p) => (p.active ? "white" : "transparent")};
    font-size: 0.7rem;
  }
`;
